<template>
    <div class="card card-custom mb-2">
        <div class="card-body px-3 pt-3 pb-1">
            <div ref="statsBox" class="row align-items-center">
                <div class="col">
                    <div class="d-flex flex-wrap align-items-center">
                        <div v-for="(c,i) in config.items" :key="i+'-recapt-card'"
                            class="px-4 py-2 mr-2 mb-2 min-w-180px" :class="c.bgClass || 'bg-light-info'"
                            style="border-radius:8px">
                            <div class="d-flex align-items-center mr-2">
                                <div class="symbol symbol-45 symbol-light-secondary mr-4 flex-shrink-0">
                                    <div class="symbol-label">
                                        <span class="svg-icon svg-icon-lg svg-icon-info">
                                            <i :style="{ 'color': c.color || '#000' }"
                                                :class=" c.icon || 'ri-global-line'" class="ri-2x"></i>
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <div class="font-size-sm text-dark-75 font-weight-bold mt-1">{{ c.label }}</div>
                                    <div :style="{ 'color': c.color || '#000' }"
                                        class="font-size-h4 font-weight-bolder">{{ stats[c.id] | parse(c.numeric?
                                        'number': '') | parse(c.transform) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="config.graph && Object.values(stats).filter(x => x > 0).length" class="col-auto">
                    <apexchart :height="boxHeight" :options="graphChart.options" :series="graphChart.series" ></apexchart>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'default-statistic',
    props: {
        config: { type: Object, required: false, default () { return {} } },
        stats: { type: Object, required: false, default () { return {} } }
    },
    data () {
        return {
            graphChart: {
                options: {
                    chart: {
                        type: this.config.graph.type || 'bar',
                        toolbar: {
                            show: false
                        },
                        sparkline: {
                            enabled: true
                        }
                    },
                    colors: this.config.items.map(x => x.color || '#26a0fc'),
                    plotOptions: {
                        bar: {
                            horizontal: this.config.graph.horizontal || false,
                            dataLabels: {
                                position: 'top'
                            },
                            borderRadius: 8,
                            distributed: true,
                            columnWidth: '90%'
                        }
                    },
                    grid: {
                        padding: {
                            top: this.config.graph.horizontal ? 0 : 15,
                            right: this.config.graph.horizontal ? 0 : 0
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetY: this.config.graph.horizontal ? 0 : -20,
                        offsetX: this.config.graph.horizontal ? -10 : 0,
                        formatter: (value) => { return Number(value).toLocaleString('id-ID') },
                        style: {
                            fontSize: '12px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 'bold',
                            colors: ['#000']
                        }
                    },
                    noData: {
                        text: 'Loading Chart Data',
                        align: 'center',
                        verticalAlign: 'middle',
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: undefined,
                            fontSize: '14px',
                            fontFamily: undefined
                        }
                    },
                    xaxis: {
                        type: 'category',
                        position: 'bottom',
                        labels: {
                            show: false
                        }
                    },
                    yaxis: {
                        labels: {
                            show: false
                        }
                    },
                    tooltip: {
                        shared: true,
                        intersect: false,
                        marker: false,
                        y: {
                            formatter: (value) => { return value ? value.toLocaleString('id-ID') : 0 }
                        }
                    },
                    legend: {
                        show: false
                    }
                },
                series: [{
                    name: 'Statistik Data',
                    data: []
                }]
            },
            boxHeight: 80
        }
    },
    watch: {
        stats: {
            deep: true,
            immediate: true,
            handler (e) {
                if (e && Object.values(e).filter(x => x > 0).length && this.config.graph) this.buildGraph(e)
            }
        }
    },
    mounted () {
        this.calculateHeight()
    },
    methods: {
        calculateHeight () {
            this.boxHeight = this.$refs.statsBox.clientHeight || 50
        },
        buildGraph (e) {
            const filtered = this.config.items.filter(x => this.config.graph.categories.includes(x.id))
            const data = filtered.map(x => { return { x: x.label, y: e[x.id] } })
            this.$set(this.graphChart, 'series', [{
                name: 'Statistik Data',
                data: data
            }])
        }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/base/component/statistic-table.vue